const ENCODE_MAP: { [key: string]: string } = {
  '\\"': '&quot&',
  "\\'": '&apos&',
  '\\': '&sprit&'
}

const DECODE_MAP: { [key: string]: string } = {
  '&quot&': '"',
  '&apos&': "'",
  '&sprit&': '\\'
}

export const base64ToUtf8 = (base64Str: string): string => {
  if (typeof base64Str !== 'string') return base64Str

  const normalized = base64Str.replace(/-/g, '+').replace(/_/g, '/')
  const mod = normalized.length % 4
  const padded = mod === 2 ? normalized + '==' : mod === 3 ? normalized + '=' : normalized
  if (mod === 1) {
    throw new Error('Invalid base64 string')
  }

  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new TextDecoder().decode(bytes)
}

const processObjectStrings = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null || obj === undefined || obj === '') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => processObjectStrings(item))
  }

  const result: { [key: string]: any } = {}
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      if (['playerName', 'nickName', 'receiverName', 'senderName'].includes(key)) {
        result[key] = base64ToUtf8(value)
      } else {
        if (typeof value === 'string') {
          result[key] = value.replace(/&quot&|&apos&|&sprit&/g, (match) => DECODE_MAP[match])
        } else {
          result[key] = processObjectStrings(value)
        }
      }
    }
  }
  return result
}

export const processJsonString = (jsonString: string): any => {
  try {
    let processedString = jsonString.replace(/\\"/g, ENCODE_MAP['\\"'])
    processedString = processedString.replace(/\\'/g, ENCODE_MAP["\\'"])

    processedString = processedString.replace(/\\/g, ENCODE_MAP['\\'])

    const parsedObj = JSON.parse(processedString)

    return processObjectStrings(parsedObj)
  } catch (error) {
    console.error('处理JSON字符串时出错:', error)
    return null
  }
}
